/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from 'react'

import HeaderSection from './headerSection'
import Footer from './footer'
import './layout.css'

const Layout = ({ header = {}, children }) => {
  return (
    <div id='mainContainer'>
      <HeaderSection header={header} />
      <div>
        <main>{children}</main>
      </div>
      <Footer />
    </div>
  )
}

export default Layout
